<template>
    <transition name="modal-fade">
        <div class="modal-back">
            <div class="modal-backdrop">
                <div
                    class="modal"
                    role="dialog"
                    aria-labelledby="modalTitle"
                    aria-describedby="modalDescription"
                >
                    <header class="modal-header" id="modalTitle">
                        <slot name="header">
                            <h2>Choose Subject which you are Interested in</h2>

                            <button
                                type="button"
                                class="btn-close d-none"
                                @click="close"
                                aria-label="Close modal"
                                style="visibility: hidden;"
                            >
                                x
                            </button>
                        </slot>
                    </header>
                    <section class="modal-body" id="modalDescription">
                        <slot name="body">
                            <form id="checkbox_group">
                                <div class="row mb-3">
                                    <div
                                        class="col-4 my-3"
                                        v-for="(subject, index) in gradeSubjects"
                                        @click="onCheckBoxChange(subject.id)"
                                        v-bind:key="index"
                                    >
                                        <div class="radio-toolbar">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :value="subject.id"
                                                :checked="selectedSubjects.includes(subject.id)"
                                            />
                                            <label class="form-check-label" :for="subject + index"
                                                >{{ subject.name }}&nbsp;<i class="fa fa-plus"></i
                                            ></label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </slot>
                    </section>
                    <footer class="modal-footer">
                        <slot name="footer">
                            <button
                                type="button"
                                class="btn-green"
                                @click="onNext"
                                aria-label="Close modal"
                                style="
                margin-right: 50px;
                width: 100px;
                height: 30px;
                font-size: 15px;
              "
                            >
                                Next
                            </button>
                        </slot>
                    </footer>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
// import $ from "jquery"
import { HTTP, getAuthorizationHeader } from "../_helper/http-constants"
import _ from "lodash"

export default {
    name: "modal",
    props: ["grade"],
    data() {
        return {
            selectedSubjects: [],
            gradeSubjects: [],
            gradeData: null,
            grades: [],
        }
    },

    async mounted() {
        console.log("fetch gradeesadfdasfds")
        await this.fetchGradeSubjects()
    },
    methods: {
        onNext() {
            if (this.selectedSubjects.length > 0) {
                let user = JSON.parse(localStorage.getItem("user"))
                HTTP.post("/users/update", {
                    email: user.email,
                    interested_subjects: this.selectedSubjects,
                }).then(() => {
                    // populate the interested subjects with the data.
                    user.interested_subjects = this.gradeSubjects.filter((item) =>
                        this.selectedSubjects.includes(item._id)
                    )
                    window.localStorage.setItem("user", JSON.stringify(user))
                    window.location.reload()
                    this.$emit("close")
                })
            }
        },
        close() {},
        onCheckBoxChange(val) {
            if (this.selectedSubjects.includes(val)) {
                this.selectedSubjects = this.selectedSubjects.filter((item) => item !== val)
            } else {
                this.selectedSubjects.push(val)
            }
        },

        async fetchGradeSubjects() {
            console.log("fetch grade subjecgts", this.grade)
            try {
                const res = await HTTP.get("/subjects?grade=" + this.grade.id, {
                    headers: getAuthorizationHeader(),
                })
                this.gradeSubjects = res.data.result
            } catch (err) {
                console.log("error in fetching grade subjects", err)
            }
        },
    },
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 20vw;
    bottom: 0;
    left: 20vw;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60vw;
    height: 60vh;
    background-color: unset !important;
}

.modal-back {
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal {
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 60%;
    height: 75%;
    top: 20%;
    left: 20%;
    box-shadow: unset !important;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4aae9b;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.btn-green:disabled {
    background: grey;
}
</style>
